(() => {
  const categoryHandles = {
    smartphone: 'smartphones',
    smartphones: 'smartphones',
    phone: 'smartphones',
    phones: 'smartphones',
    tablet: 'tablets',
    tablets: 'tablets',
    laptop: 'laptops',
    laptops: 'laptops',
    gaming: 'gaming',
    console: 'gaming',
    consoles: 'gaming',
    smartwatch: 'smartwatches',
    smartwatches: 'smartwatches',
    'smart watch': 'smartwatches',
    'smart watches': 'smartwatches',
    audio: 'audio',
    headphones: 'audio',
    earphones: 'audio',
    ring: 'rings',
    rings: 'rings',
    necklace: 'necklaces',
    necklaces: 'necklaces',
    bracelet: 'bracelets',
    bracelets: 'bracelets',
    earring: 'earrings',
    earrings: 'earrings',
    pendant: 'pendants',
    pendants: 'pendants',
    bangle: 'bangles',
    bangles: 'bangles'
  };

  const queryAliases = {
    iphones: 'iphone',
    ipads: 'ipad',
    macbooks: 'macbook'
  };

  const clean = (value = '') => value
    .replace(/\btitle:/gi, '')
    .replace(/\s+/g, ' ')
    .trim();

  const normalise = (value = '') => clean(value).toLowerCase();

  const titleQuery = (value = '') => {
    const cleaned = clean(value);
    const aliased = queryAliases[cleaned.toLowerCase()] || cleaned;

    return aliased
      .split(' ')
      .filter(Boolean)
      .map((term) => `title:${term}`)
      .join(' ');
  };

  window.UnboxedSearchRelevance = {
    categoryHandle(value) {
      return categoryHandles[normalise(value)] || '';
    },
    clean,
    query(value) {
      return this.categoryHandle(value) ? clean(value) : titleQuery(value);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    const input = form?.querySelector('input[name="q"]');

    if (!form || !input) return;

    const searchTerm = clean(input.value);
    if (!searchTerm) return;

    const categoryHandle = window.UnboxedSearchRelevance.categoryHandle(searchTerm);
    if (categoryHandle) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const searchUrl = new URL(form.action, window.location.origin);
      const storefrontRoot = searchUrl.pathname.replace(/search\/?$/, '');
      window.location.assign(`${storefrontRoot}collections/${categoryHandle}`);
      return;
    }

    input.value = titleQuery(searchTerm);
  }, true);
})();
